export interface SetupFee {
  name: string;
  value: number;
}

export function createSetupFee(_name: string, _value: number): SetupFee {
  return { name: _name, value: _value };
}

export interface SalesTax {
  name: string;
  value: number;
}

export function createSalesTax(_name: string, _value: number): SalesTax {
  return { name: _name, value: _value };
}

export interface PriceType {
  name: string;
  friendlyName: string;
}

export function createPriceType(_name: string, _friendlyName: string): PriceType {
  return { name: _name, friendlyName: _friendlyName };
}
